__turbopack_context__.v({
  "body": "popoverwrapper-module-scss-module__ldrFWa__body",
  "button": "popoverwrapper-module-scss-module__ldrFWa__button",
  "contentWrapper": "popoverwrapper-module-scss-module__ldrFWa__contentWrapper",
  "defaultButton": "popoverwrapper-module-scss-module__ldrFWa__defaultButton",
  "headerContent": "popoverwrapper-module-scss-module__ldrFWa__headerContent",
  "outerWrapper": "popoverwrapper-module-scss-module__ldrFWa__outerWrapper",
});
